














import Vue from 'vue'
import Authenticated from './helpers/Authenticated.vue'
import AdminOnly from './helpers/AdminOnly.vue'
import NewRestaurant from '@/components/admin/NewRestaurant.vue'
import RestaurantList from '@/components/admin/RestaurantList.vue'
import AllUsers from '@/components/admin/AllUsers.vue'
import AdminMenu from '@/components/admin/AdminMenu.vue'

export default Vue.extend({
  name: 'AdminUsers',
  components: { Authenticated, AdminOnly, NewRestaurant, RestaurantList, AllUsers, AdminMenu },
})
